module.exports = __webpack_public_path__ + "img/slide-1__sm.69dc2570.jpg";